import styled from 'styled-components'
import { Flex } from 'grid-styled'
import Modal from 'react-modal'

import theme from '../../../../../../theme'

export const GalleryPopup = styled(Modal)`
  max-height: 90vh;
  max-width: 90vw;
  margin: 10vh 10vw 10vh 10vw;
`

export const Gallery = styled(Flex)`
  height: 100%;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: auto;
  align-items: center;
  justify-content: space-evenly;
`

export const PopupGallery = styled(Flex)`
  height: 100%;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  align-items: center;
`

export const Button = styled.button`
  outline: none;
  background-color: transparent;
  border-color: transparent;
`

export const Photo = styled.img`
  display: inline-block;
  margin: 10px;
  max-width: ${props => `${55 / props.columns}vw`};
  max-height: ${props => `${45 / props.rows}vh`};
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 1px 1px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
  }
`

export const GalleryPhoto = styled.img`
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
`

export const X = styled(Flex)`
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  color: ${theme.colors.white};
  padding: 20px;
  &:hover {
    color: gray;
  }
  justify-content: flex-start;
  cursor: default;
`



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/components/PhotoGallery/styles.js